import { Link } from 'src/components/Link';
import Stack from '@mui/material/Stack';
import { TypographyTruncated } from 'src/components/TypographyTruncated';
import { AvatarNext } from 'src/components/AvatarNext';

export type UsernameProps = {
  imgUrl?: string;
  name: string;
  rank: number;
  userIdCaptain: string;
};

export const Username = ({
  imgUrl,
  name,
  rank,
  userIdCaptain,
}: UsernameProps) => {
  const typographyVariant = rank > 3 ? 'body2' : 'body1';
  const fontWeight = rank <= 3 ? 700 : 400;

  return (
    <Link
      href={`/profile/${userIdCaptain}/inventory`}
      sx={{ textDecoration: 'none' }}
    >
      <Stack flexDirection="row" justifyContent="center" alignItems="center">
        {!!imgUrl && <AvatarNext src={imgUrl} alt={name} />}
        <TypographyTruncated
          text={name}
          textMaxLength={20}
          variant={typographyVariant}
          sx={{ ml: '8px', fontWeight }}
        />
      </Stack>
    </Link>
  );
};
